<template>
    <div class="view-news-page">
        <fancy-header></fancy-header>
        <div class="container">
            <div class="loading getmore-div" v-show="isLoading">
                <div class="fas fa-spinner fa-spin" >
                </div>
            </div>
            <div class="row" v-show="!isLoading">
                <div class="col-xs-12 news-container">
                    <div class="news-image">
                        <div class="img-container">
                            <div class="content">
                                <img :src="news.Image.Url">
                            </div>
                        </div>
                    </div>
                    <div class="news-content">
                        <div class="title-section">
                            <h2>{{ news.Title }}</h2>
                        </div>
                        <div class="meta-section">
                            <p><span class="fa fa-calendar"></span><span>{{ publishDate }}</span></p>
                            <p><span class="fa fa-tags"></span><span>{{ news.Tags.map(c => c.Title).join(', ') }}</span></p>
                        </div>
                        <div class="news-description" v-html="news.Description">
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import FancyHeader from '@/components/shared/fancy-header'
    import RelatedProducts from '@/components/products/related-products'
    import ProductPricingOrder from '@/components/products/pricing-order'

    export default {
        name: 'ViewNews',

        data: () => ({
            id: 0,
            news: {
                Title: null,
                Description: null,
                PublishDate: null,
                Image: {
                    Url: null
                },
                Tags: [],
            },
            isLoading: false,
        }),

        computed: {
            publishDate: function () {
                return this.news.PublishDate === null ? "" : new Date(this.news.PublishDate).toLocaleDateString();
            }
        },

        mounted() {
            this.id = this.$route.params.id;
            this.isLoading = true;
            
            axios.get(apiHost + "/news/" + this.id)
                .then((response) => {
                    this.news = response.data;
                }).finally(() => this.isLoading = false);
        },

        components: {
            FancyHeader,
        }
    }
</script>
<style lang="scss">
    @import "src/assets/sass/app.scss";

    .view-news-page {
        & > .container {
            margin-top: 30px;
            margin-bottom: 30px;
        }
        direction: $dir;
        @include text-align($dir);
        .news-container {
            .news-image {
                @include float-right($dir);
                border-radius: 10px;
                border: 2px solid #fff;
                width: 25%;
                @media (max-width: 767px) {
                    width: 30%;
                }
                @media(max-width: 480px) {
                    width: 100%;
                    margin-bottom:20px;
                    clear:both;
                }
                .img-container {
                    width: 100%;
                    @include aspect-ratio(4, 3);
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .news-content {
                 @media(max-width: 480px) {
                   padding-left:15px;
                   padding-right:15px;
                }
                .title-section {
                    margin-top: 10px;
                    margin-bottom: 10px;
                }
                .meta-section {
                    p {
                        direction: $dir;
                        span {
                            @include margin-right(10px, $dir);
                            &.fa {
                                color: #ccc;
                            }
                        }

                    }
                }
                .news-description {
                    direction: $dir;
                    @include text-align($dir);
                    font-size: 18px;
                }
            }
        }
        .loading.getmore-div{
            text-align:center;
            margin-top:15px;
            height: 200px;
            .fa-spin{
                font-size:20px;
                color:$main-color;
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/news and events/view-news.vue